import cx from 'classnames';
import CircularLoading from 'components/base/loading/CircularLoading';
import PageTitle from 'components/base/title/PageTitle';
import MuiButton from 'components/common/button/MuiButton';
import MuiWrapper from 'components/common/input/MuiWrapper';
import CustomSpan from 'components/common/text/CustomSpan';
import AppItemCardList from 'components/store/AppItemCardList';
import AppStoreContainer from 'containers/store/AppStoreContainer';
import { pageUrl } from 'lib/mapper';
import { ILoginUser } from 'lib/types/sharedTypes';
import { IProduct } from 'lib/types/storeTypes';
import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { NavLink, useHistory, useLocation } from 'react-router-dom';
import { StoreActions } from 'store/actionCreators';
import { useShallowAppSelector } from 'store/hooks';
import styled from 'styled-components';
import { beforeDash, color } from 'styles/utils';

// TEST: api data

function StoreContainer() {
  const {
    user,
    fetchStoreProducts: { productList },
    fetchStoreProductSuccess,
    fetchStoreProductPending,
    language,
  }: {
    user: ILoginUser;
    fetchStoreProducts: { productList: IProduct[] };
    fetchStoreProductSuccess: boolean;
    fetchStoreProductPending: boolean;
    language: string;
  } = useShallowAppSelector(state => ({
    user: state.user.user || {},
    fetchStoreProducts: state.store.storeProducts.data || { productList: {} },
    fetchStoreProductSuccess: state.store.storeProducts.success,
    fetchStoreProductPending: state.store.storeProducts.pending,
    language: state.base.language,
  }));
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const lastUrl = pathname.split('/').pop();
  const history = useHistory();
  // const storeProducts = fetchStoreProducts?.productList;
  // const [selectedTab, setSelectedTab] = useState<object | any>();
  const [selectedTabIdx, setSelectedTab] = useState(0);
  // const [productList, setProductList] = useState<object | any>();
  // const productListValue = testStoreProducts.find(item => item.idx === selectedTabIdx)?.productList;
  // const productListValue = fetchStoreProducts?.productList;

  // NOTE: 추후 warrnaty, storage 기획 완료 시 추가
  const storeTabList = useMemo(() => {
    return [
      // {
      //   idx: 0,
      //   mainPath: pageUrl.store.data,
      //   path: [pageUrl.store.data, pageUrl.store.index],
      //   type: 'storage',
      //   title: 'Sync storage',
      //   infoTitle: 'The easiest way to share \nthe scan data with your partners.',
      //   infoDetail:
      //     "Lorem Ipsum is simply dummy text of the printing and typesetting industry. \nLorem Ipsum has been the industry's standard dummy text ever since the \n 1500s, when an unknown printer took a galley of type and scrambled it to \nmake a type specimen book. It has survived not only five centuries, but \nalso the leap into electronic typesetting, remaining essentially unchanged.",
      //   component: <StorageItemCardList productList={productList} />,
      // },
      {
        idx: 1,
        mainPath: pageUrl.store.app,
        // NOTE: 추후 warrnaty, storage 기획 완료 시 추가, path 하단 주석으로 변경
        path: [pageUrl.store.app, pageUrl.store.index],
        // path: [pageUrl.store.app],
        type: 'apps',
        title: 'Apps',
        infoTitle: 'You’re able to do more with\nyour DOF product than ever before.',
        infoDetail:
          "Lorem Ipsum is simply dummy text of the printing and typesetting industry. \nLorem Ipsum has been the industry's standard dummy text ever since the \n 1500s, when an unknown printer took a galley of type and scrambled it to \nmake a type specimen book. It has survived not only five centuries, but \nalso the leap into electronic typesetting, remaining essentially unchanged.",
        component: <AppItemCardList productList={productList} />,
      },
      // {
      //   idx: 2,
      //   mainPath: pageUrl.store.warranty,
      //   path: [pageUrl.store.warranty],
      //   type: 'warranty',
      //   title: 'Warranty',
      //   infoTitle: 'One stop for technical support, DOF \nhardware service, and software support.',
      //   infoDetail:
      //     "Lorem Ipsum is simply dummy text of the printing and typesetting industry. \nLorem Ipsum has been the industry's standard dummy text ever since the \n 1500s, when an unknown printer took a galley of type and scrambled it to \nmake a type specimen book. It has survived not only five centuries, but \nalso the leap into electronic typesetting, remaining essentially unchanged.",
      //   component: <WarrantyItemCardList productList={productList} />,
      // },
    ];
  }, [productList]);

  useEffect(() => {
    const storeType = storeTabList.find(item => item.path.includes(pathname))?.idx;
    StoreActions.fetch_store_product_list_request({
      type: storeType,
      currency: user.currencyCode,
      language: language,
    });
    // console.log(' storeType ____________________________ ', storeType);
  }, [pathname]);

  // useEffect(() => {
  //   // init
  //   StoreActions.fetch_store_product_list_request({ type: selectedTabIdx, currency: 'KRW' });
  // }, []);

  // useEffect(() => {
  //   StoreActions.fetch_store_product_list_request({ type: selectedTabIdx, currency: 'KRW' });
  // }, [selectedTabIdx]);

  const handleClickStoreTab = (index: number) => {
    setSelectedTab(index);
    // Tab 별 Product List API호출
  };

  useEffect(() => {
    // container init
    // 0번(storage) Tab Alarm, Product List 호출
  }, []);

  return (
    <StyledStore data-component-name="Store">
      <PageTitle title={t('NAV_MENU_STORE')} />

      <div className="store__tabs_wrapper">
        {storeTabList.map((item: any, index: number) => {
          return (
            <NavLink to={item.mainPath} className="appNav__link" key={index}>
              <MuiWrapper className="store__tabs_btn_wrapper">
                <MuiButton
                  config={{
                    width: '200px',
                    height: '45px',
                  }}
                  name={item.type}
                  disableElevation
                  className={cx('store__tabs_btn', {
                    // selected: selectedTabIdx === item.idx,
                    selected: !!item.path.includes(pathname),
                    // selected: pathname === item.path,
                  })}
                  variant="outlined"
                  onClick={() => {
                    handleClickStoreTab(item.idx);
                  }}
                  // onClick={handleClickStoreTab}
                >
                  <CustomSpan fontSize={20} fontWeight={400}>
                    {item.title}
                  </CustomSpan>
                </MuiButton>
              </MuiWrapper>
            </NavLink>
          );
        })}
      </div>

      {/* NOTE: 추후 warrnaty, storage 기획 완료 시 추가 */}
      {/* <div className="store__container">
        {useMemo(
          () => (
            <>
              {(pathname === pageUrl.store.index || pathname === pageUrl.store.data) && (
                <StorageStoreContainer />
              )}
              {pathname === pageUrl.store.app && <AppStoreContainer />}
              {pathname === pageUrl.store.warranty && <WarrantyStoreContainer />}
            </>
          ),
          [pathname],
        )}
      </div> */}
      <div className="store__container">
        {useMemo(
          () => (
            <>
              {(pathname === pageUrl.store.index || pathname === pageUrl.store.app) && (
                <>
                  {!!fetchStoreProductPending ? (
                    <div className="store__container_progress">
                      <CircularLoading size={40} />
                    </div>
                  ) : (
                    <AppStoreContainer />
                  )}
                </>
              )}
            </>
          ),
          [pathname],
        )}
      </div>
    </StyledStore>
  );
}

const StyledStore = styled.section<{}>`
  /* padding-bottom: 120px; */
  // Storage 인 경우
  .store__tabs_wrapper {
    margin-top: 20px;
    margin-bottom: 30px;
    .store__tabs_btn_wrapper {
      height: 45px;
      margin-right: 10px;
      .store__tabs_btn {
        text-transform: none;
        color: #b5b7c1;
        &.selected {
          border: none;
          /* background: linear-gradient(to right, rgba(0, 166, 266, 1), rgba(8, 123, 238, 1)); */
          background-color: #00a6e2;
          color: #ffffff;
        }
      }
    }
  }

  .store__container {
    position: relative;
    width: 100%;
    /* height: 1030px; */
    box-shadow: 0px 0px 10px rgb(0 0 0 / 16%);
    border-radius: 15px;
    background-color: #fff;
    /* padding-bottom: 40px; */
    /* padding-bottom: 38px; */
    /* padding: 0 50px 50px; */
    .store__container_progress {
      width: inherit;
      height: inherit;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  .store__alarm_wrapper {
    width: 100%;
    padding: 30px 50px 20px;
    .store__alarm_container {
      border-radius: 40px;
      background-color: #edf4fb;
      width: 100%;
      padding: 25px 0;
      .store__alarm_icon_box {
        width: 135px;
        position: relative;

        .store__alarm_icon {
          position: absolute;
          left: 0;
          bottom: -25px;
          img {
            width: 135px;
            height: 110px;
          }
        }
      }
      .store__alarm_text_box {
        p {
          line-height: 28px;
        }
      }
    }
  }

  .store__list_wrapper {
    .store__list_title {
      font-size: 21px;
      font-weight: 800;
      color: #17288a;
      ${beforeDash({ backgroundColor: color.navy_blue })};
    }
  }
`;

export default React.memo(StoreContainer);
